import type { SurveyResponse } from "@qendo/survey";
import type { DiagnosisTime, GoodNeutralBadNa, YesNoNa, YesNoPreferNotToSay } from "@qendo/survey/fields";
import type { AgeRange, Gender } from "@qendo/types";
import type { DateArg } from "date-fns";
import Data, { type DataProperty } from "~/util/data";

export class OnboardingSurveyData extends Data implements SurveyResponse {
    constructor(
        public postcode: string = "",
        public age_range: AgeRange | null = null,
        public date_of_birth: DateArg<Date> | null = null,
        public medicare: string = "",
        public gender: Gender | "" | null = null,
        public gender_description: string = "",
        public aboriginal_or_torres_straight_islander: YesNoPreferNotToSay | null = null,
        public language: string = "",
        public information_language: string = "",
        public disability: YesNoPreferNotToSay | null = null,
        public diagnosis: string[] = [],
        public diagnosis_time: DiagnosisTime | null = null,
        public symptoms: string[] = [],
        public unplanned_visits: YesNoNa | null = null,
        public visiting_gp: GoodNeutralBadNa | null = null,
        public employment_tools: GoodNeutralBadNa | null = null,
        public movement: GoodNeutralBadNa | null = null,
        public eating_habits: GoodNeutralBadNa | null = null,
        public mental_health: GoodNeutralBadNa | null = null,
        public daily_activities: GoodNeutralBadNa | null = null,
    ) {
        super();
    }

    public valid(): boolean {
        return this.filled([
            "postcode",
            "age_range",
            "date_of_birth",
            "aboriginal_or_torres_straight_islander",
            "language",
            "disability",
            "unplanned_visits",
            "visiting_gp",
            "employment_tools",
            "movement",
            "eating_habits",
            "mental_health",
            "daily_activities",
        ] as DataProperty<this>[]);
    }
}
